import React,{useState,useEffect} from 'react';
import {Table,TableBody,TableCell,TableContainer,TableHead,TableRow
        ,Card,TextField,Box, Paper,Tooltip,IconButton, Typography} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
const useStyles = makeStyles({
    root: {
      width: '100%',
    },
    estiloCard:{
        width: '35rem',
        boxShadow:'0 0.5em 1em -0.125em rgb(10 10 10 / 10%), 0 0 0 1px rgb(10 10 10 / 2%)',
       // color:'#4a4a4a',
        display:'block',
        padding:'.5rem',
        maxHeight:'100%',
        minHeight: 280,
        marginRight:'.5rem'
    },
    formControl:{
        boxSizing:'border-box',
        fontSize:'1rem',
        position:'relative',
        marginBottom:'1em'
    },
    container: {
      width: '34rem',
      minHeight: '25rem',
      //minWidth:'100%',
    },
    tablaContainer: {
        width: '34rem',
        maxHeight: '26.5rem',
        minHeight: 280,
        //minWidth:'100%',
      },
    totalEstilo:{
        fontSize:'1.25rem',
        fontWeight:'bold'
    },
    tituloEstilo:{
        paddingBottom:'.25rem',
        fontWeight:'bold'
    },
    tableRow: {
      "&$selected, &$selected:hover": {
        backgroundColor:process.env.REACT_APP_Color_Second
      }
    },
    tableCell: {
      "$selected &": {
        color: "white"
      }
    },
    hover: {},
    selected: {}
  });
  const columnas=[                    
    {
      id:1, titulo:"Municipio", alinear:'center'
    },     
    { id:5, titulo:"Hombre", alinear:'center' },      
    { id:6, titulo:"Mujer", alinear:'center' },      
    { id:7, titulo:"No Binario", alinear:'center' },      
   /*  {
      id:2, titulo:"Pendiente", alinear:'center'
    },      
    {
      id:3, titulo:"Valido", alinear:'center'
    },      
    {
      id:4, titulo:"Rechazado", alinear:'center'
    },   */    
  ];

const alturaCont = window.innerHeight<937 ? window.innerHeight-250 : window.innerHeight-270

export default function TablaMun({listAvMun,registro, setRegistro,registroEdo,listAvEdo,tipoTabla}){    
  const classes = useStyles();    
  const [promotor, setPromotor] = useState({nombre:""})
  const [seleccion, setSeleccion] = useState(null)
  const [datos,setDatos] = useState([]);     
  const [totalGen,setTotalGen] = useState([]);     
  const auxCol=process.env.REACT_APP_Fondo_Color
  const {nombre} = promotor;    
  useEffect(()=>{
    
    
    if (tipoTabla===2) {
      if (listAvMun.length!==0 &&listAvMun[0].avc_gral&& listAvMun[0].avc_gral[0].EdoId!==0) {
        console.log(listAvMun);
        let aux={totHom:0, GenX:0, totMuj:0, avGen:0, MetaGen:0}
         listAvMun[0].avc_gral.forEach(element => {
           aux={ totHom:aux.totHom +element.GenH,
             totMuj: aux.totMuj +element.GenM,
             GenX:aux.GenX +element.GenX,
             avGen:aux.avGen +element.Avc,
             MetaGen:aux.MetaGen +element.Meta
            }
         });
         setDatos(listAvMun[0].avc_gral)  
         setTotalGen(aux)
       }else
       {
         setDatos([])
       }  
    }
    else{console.log(listAvEdo);
      if (listAvEdo.length!==0 &&listAvEdo[0].avc_gral&& listAvEdo[0].avc_gral[0].EdoId!==0) {
        //console.log(registroEdo);
        let aux={totHom:0, GenX:0, totMuj:0, avGen:0, MetaGen:0}
         listAvEdo[0].avc_gral.forEach(element => {
          aux={ totHom:aux.totHom +element.GenH,
            totMuj: aux.totMuj +element.GenM,
            GenX:aux.GenX +element.GenX,
            avGen:aux.avGen +element.Avc,
            MetaGen:aux.MetaGen +element.Meta,}
         });
         setDatos(listAvEdo[0].avc_gral)  
         setTotalGen(aux)
       }else
       {
         setDatos([])
       }
    }

    //la siguiente linea puede generar errores o no en el useEffect
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[listAvMun,tipoTabla])          

  const onChangeTable =(regis)=>{    
    if (tipoTabla===2) {
      setRegistro(regis)  
    }                       
  }

  function filtro(){        
    let auxCadena=nombre.trim();       
    let info=[];                        
    let aux=  datos.filter((dat)=>dat.nombreReg.toUpperCase().search(auxCadena.toUpperCase() ) !== -1)         
    info=aux 
    let auxNum=0;
      if (aux!==null||aux!=='') 
      {
      aux.forEach((mun)=>
      { if (mun.nombreReg!=='PUEBLA')
        {   
          auxNum++;
        }                
      })
    }         
    return TablaEstr(info);
  }

  const celda = (alinear, estilo, contenido,index) => {
    return (
    <TableCell align={alinear} key={index} className={classes.tableCell} 
        padding={'none'} style={estilo} >
        {contenido}
    </TableCell>)
  }

  const CelTitl=({index,titulo,aline})=> celda(aline?aline:"center", {backgroundColor:auxCol,color:'white',}, titulo?titulo:"",index) 

  const colorStatus=(status)=>{
    let stdColor=""
    if (status<25) 
    { stdColor="#E91E63"      
    }
    else
    { if (status<50) 
      {
        stdColor="#f07111"      
      }
      else
      {
        if (status<75) 
        { stdColor="#FBBE06"      
        }
        else
        { stdColor="#19A11E"                        
        }         
      } 
    }
    return(
    <Box display={"flex"}  justifyContent="flex-end" style={{textAlign:"right",alignItems:"center",fontSize:"12px"}}>            
      {`${status.toFixed(2)}%`}
      <FiberManualRecordIcon size="small" style={{color:stdColor,}}/>      
    </Box>)
  }

  function TablaEstr(auxDatos) {        
    
    return(        
    <TableContainer className={classes.tablaContainer} id="tamTablaReg"  >
      <Table stickyHeader aria-label="sticky table">
        <TableHead >    
          {/* <TableRow>  
        
            {columnas.map((columna,index)=>              
              <CelTitl index={index+5} titulo={columna.titulo} aline={columna.alinear} />                          
            )}                                       
          </TableRow>     */}
         { totalGen.length!==0 ?
         <TableRow>
          <CelTitl index={1} titulo={tipoTabla === 2 ? "Municipio":"Estado" } aline={"left"} />         
          <CelTitl index={2} titulo={<span>Meta <br/> <strong>{totalGen.MetaGen}</strong></span> } aline={"center"} />   
          <CelTitl index={3} titulo={<span>Avance <br/><strong>{totalGen.avGen}</strong></span>  } aline={"center"} />                         
          <CelTitl index={4} titulo={"" } aline={"center"} />         
          <CelTitl index={5} titulo={<span>Hombre <strong>{totalGen.totHom}</strong></span>} aline={"center"} />         
          <CelTitl index={6} titulo={<span>Mujer <br/><strong>{totalGen.totMuj}</strong></span>} aline={"center"} />         
          <CelTitl index={7} titulo={<span style={{fontSize:"12px"}}>No Binario <br/> <strong>{totalGen.GenX}</strong></span>} aline={"center"} />                             
          </TableRow>
          :null }                   
        </TableHead>  
        <TableBody> 
        {/* <TableRow className={classes.tableRow} selected={ registro?.Id === 0} 
          classes={{ hover: classes.hover, selected: classes.selected }} 
          key={0} onClick={ () => onChangeTable({Id:0,Num:0}) }  
        >   
         
          {celda("center", {width:"2rem"}, "GENERAL",0) }                                                                  
        </TableRow> */}
        {auxDatos.map((elemnto,index) => {  
          const auxVal=registro?.MunId === elemnto.MunId ?true:false                                              
          return (                  
          <TableRow className={classes.tableRow} selected={ auxVal} 
            classes={{ hover: classes.hover, selected: classes.selected }} 
            key={index+1} onClick={ () => onChangeTable(elemnto) }  
          >   
            {celda("left", {width:"8rem"}, tipoTabla === 2 ? elemnto.MunNom:elemnto.EdoNom ,index+1) }        
            {celda("center", {width:"4rem"}, elemnto.Meta ,index+2) }
            {celda("right", {width:"4rem"}, elemnto.Avc ,index+3) }
            {celda("right", {width:"6rem"}, colorStatus(elemnto.Porcent),index+4) }
            {celda("right", {width:"4rem"}, elemnto.GenH,index+5) }
            {celda("right", {width:"4rem"}, elemnto.GenM,index+6) }
            {celda("right", {width:"4rem",paddingRight:".3rem"}, elemnto.GenX,index+7) }     
          </TableRow>              
          );                        
          })
        }                                                
        </TableBody>
      </Table>
    </TableContainer>        
    ); 
  }
                   
    const contenido = nombre.length > 0 ? (filtro()):(TablaEstr(datos));    
    const llamada= datos.length !== 0 ?(contenido):(<Box style={{paddingTop:1+'rem'}}>
                                    <Typography variant="h5" component="h5">No contiene datos</Typography>
                                    </Box>)
                                                                                
                           
                                
  return (
  <Box display={'flex'} flexDirection="row" style={{height: '29rem',marginLeft:"1rem"}}>
    <Card className={classes.estiloCard} style={{height:window.innerHeight-140}}>                        
      {tipoTabla ===2 ?<Typography variant="body1" component="body1">{registroEdo.Num}</Typography> :null }
      {llamada}   
    </Card>

  </Box>                    
  );
}